// extracted by mini-css-extract-plugin
module.exports = {"label-content":"index_label-content_24ZcT","itemLists":"index_itemLists_1rCvf","item":"index_item_2nqqJ"};